import { ButtonBase } from '@mui/material';
import {
  Button,
  Checkbox,
  Collapse,
  Divider,
  Dropdown,
  Input,
  InputNumber,
  Modal,
  Popover,
  Select,
  Tabs,
} from 'antd';
import { FiCalendar, FiDollarSign } from 'react-icons/fi';
import { FaCarSide } from 'react-icons/fa';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from '../../axios/axios';
import PageLoader from '../../components/PageLoader';
import { useContext, useEffect, useState } from 'react';
import SwitchBox from '../LoanProduct/SwitchBox';
import BonusSwitchBox from '../SingleProduct/BonusSwitchBox';
import SwitchButton from '../LoanProduct/SwitchButton';
import { AuthenticationContext } from '../../App';
import LoaderComp from '../../components/LoaderComp';
import BankCard from '../LoanProduct/BankCard';
import { useForm, Controller } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import IntSwitchButton from '../SingleProduct/IntSwitchButton';
import LongBankCard from './LongBankCard';
import { IMAGE_BASE_URL } from '../../common/Constants';
import LnSwitchBox from './LnSwitchBox';
import ViewBonusPopup from './ViewBonusPopup';
import SelAgentCard from './SelAgentCard';
import SelAgentPopup from './SelAgentPopup';
import { toast } from 'react-toastify';
import ConfirmationModal from './modals/ConfirmationModal';
import { clearLocalStorageExceptOne } from '../../common/Utilities';
import { ServerAPI } from '../../common/ServerAPI';
import { useDispatch, useSelector } from 'react-redux';
import { setInitialLoanApplicationFilter } from '../../redux/slice/dealerCommFilterSlice';
const schemeContent = (
  <div className='w-[350px] p-[10px] max-w-full'>
    Min PARF Value is the value that's guaranteed by LTA at the end of the 1st
    10yrs COE cycle of the vehicle. LTA will allow vehicle owners to encash when
    they deregister their vehicle. If the owner decides to renew COE on that
    vehicle, the PARF rebates will be forfeited
  </div>
);

const DefaultFilter = {
  bonus: 'all',
  approvalTime: '', // Approval Time
  index: '0',
  keyword: '', // search
  loanType: '', // Type
  ltv: '', // Loan to Value
  motorType: '', // Motor
  toggleSwitch: 'lt',
  //productType:"", // top filter
  scheme: '', // scheme
  sortKey: 'featured', // name
  sortOrder: 'desc', // asc
  usage: '', // Usage,
  category: '',
  vehicle: '',
  collect_first_installment: 'all',
};
const LoanAppl = () => {
  const location = useLocation();
  const pagePermission = location.state;
  const navigate = useNavigate();
  const dispacth = useDispatch();
  const initialLoanApplicationFilter = useSelector(
    (state) => state?.dealerCommFilter?.initialLoanApplicationFilter
  );

  const [selectedBonus, setSelectedBonus] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [filterChangeConfirmation, setFilterChangeConfirmation] =
    useState(false);
  const [filterChangeData, setFilterChangeData] = useState({});
  const queryParams = new URLSearchParams(location.search);
  // //console.log(
  //   'queryParams',
  //   queryParams.get('loan'),
  //   queryParams.get('tenor'),
  //   queryParams.get('vehTyp'),
  //   queryParams.get('parfvalue')
  // );
  const [selectedValue, setSelectedValue] = useState(null);
  const { authData } = useContext(AuthenticationContext);
  const [tenureType, setTenureType] = useState('year');
  const methods = useForm({
    defaultValues: {
      loan_amt: '',
      loan_tnr: '',
      vehType: '',
      min_val: '',
    },
  });
  const { control, handleSubmit, watch, setValue, getValues } = methods;
  const minParfVal = watch('min_val');
  const [catgId, setCatgId] = useState('');
  const [applyFilters, setApplyFilters] = useState(
    initialLoanApplicationFilter &&
      Object.keys(initialLoanApplicationFilter).length > 0
      ? { ...DefaultFilter, ...initialLoanApplicationFilter }
      : DefaultFilter
  );
  //console.log("======", applyFilters)

  const [switchButton, setSwitchButton] = useState(true);
  const [allAgentData, setallAgentData] = useState(null);
  const [bonusPopUp, setbonusPopUp] = useState(false);
  const [viewLoan, setviewLoan] = useState(false);
  const vehType = watch('vehType');
  const [topTabCount, settopTabCount] = useState([]);
  const [productList, setProductList] = useState([]);
  const [loanTotal, setLoanTotal] = useState(0);
  const [loanProductList, setLoanProductList] = useState([]);
  const [selectedLoanDetails, setSelectedLoanDetails] = useState([]);
  const [selectedLoans, setselectedLoans] = useState([]);
  const [tabActiveKey, settabActiveKey] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selAgentPop, setselAgentPop] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [settingsIndex, setSettingsIndex] = useState(
    Object.keys(initialLoanApplicationFilter).length > 0 &&
      initialLoanApplicationFilter?.settingIndex !== undefined
      ? initialLoanApplicationFilter?.settingIndex
      : {
        veh: 0,
        cat: 0,
        typ: 0,
        schm: 0,
      }
  );
  const [orgApplLoanData, setOrgApplLoanData] = useState([]);
  const queryClient = useQueryClient();

  const updateChosedAgent = (agent, productId, providerName) => {
    // //console.log('UPDATE AGENT', agent, productId, providerName);
    //console.log("orgApplLoanData====",orgApplLoanData)
    const providerList = orgApplLoanData[providerName];
    const updatedLoanData = providerList.map((item) => {
      if (item.id === productId) {
        return {
          ...item,
          ['haveAgent']: 1,
          ['activeAgent']: agent,
        };
      } else {
        return item;
      }
    });
    //console.log('updatedLoanData======',updatedLoanData,'providerName====',providerName);
    setOrgApplLoanData((prevData) => {
      return {
        ...prevData,
        [providerName]: updatedLoanData,
      };
    });
  };
  const { isLoading, data: settingsData } = useQuery(
    ['settings-api'],
    async () => {
      const resp = await axios.get('/settings');
      const settings = resp?.data?.data;
      //console.log("settingd", settings)

      if (
        initialLoanApplicationFilter === undefined ||
        initialLoanApplicationFilter === null ||
        Object.keys(initialLoanApplicationFilter)?.length < 1
      ) {
        setApplyFilters({
          ...applyFilters,
          approvalTime: '',
          loanType: settings.categories[0].types[0].id,
          vehicle: settings.vehicles[0]?.id,
          ltv: '',
          motorType: settings.productMotorTypes[0].id,
          scheme:
            queryParams.get('parfvalue') !== '' &&
              queryParams.get('parfvalue') !== null &&
              queryParams.get('parfvalue') !== 'false'
              ? settings.categories[0].types[0].schemes[1].id
              : settings.categories[0].types[0].schemes[0].id,
          usage: settings.productUsages[0].id,
          status: 1,
          category: settings.categories[0].id,
        });
      }


      setCatgId(settings.categories[0].id);
      return resp?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  const { isFetching: prodLoading, data: productData } = useQuery(
    ['loan-product-api', applyFilters],
    async () => {
      if (applyFilters?.category !== '') {
        const resp = await axios.post(
          `/loan/product/list/24/${currentPage}`,
          {
            ...applyFilters,
            bonus: applyFilters?.bonus === 'all' ? '' : applyFilters?.bonus,
            collect_first_installment:
              applyFilters?.collect_first_installment === 'all'
                ? ''
                : applyFilters?.collect_first_installment,
          },
          {
            headers: {
              Authorization: `Bearer ${authData.token}`,
            },
          }
        );
        const product = resp?.data?.data;
        let totalProdCount = resp?.data?.total;
        // //console.log('GETLISTAPICOUNT', resp?.data);
        setLoanTotal(totalProdCount);
        setLoanProductList(product);
        // //console.log(product);
        return resp?.data?.data;
      }
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!settingsData && !queryParams.get('generate'),
    }
  );

  const GetLoanProducts = async (page) => {
    if (applyFilters?.category !== '') {
      const resp = await axios.post(
        `/loan/product/list/24/${page}`,
        {
          ...applyFilters,
          bonus: applyFilters?.bonus === 'all' ? '' : applyFilters?.bonus,
          collect_first_installment:
            applyFilters?.collect_first_installment === 'all'
              ? ''
              : applyFilters?.collect_first_installment,
        },
        {
          headers: {
            Authorization: `Bearer ${authData.token}`,
          },
        }
      );
      const product = resp?.data?.data;
      setLoanProductList(product);
      let totalProdCount = resp?.data?.total;
      setLoanTotal(totalProdCount);
      // //console.log(product);
    }
  };

  const handleScroll = () => {
    if (
      Math.round(window.innerHeight) +
      Math.round(document.documentElement.scrollTop) !==
      Math.round(document.documentElement.offsetHeight)
    ) {
      if (
        document.documentElement.offsetHeight -
        (window.innerHeight +
          Math.round(document.documentElement.scrollTop)) <=
        1
      ) {
        // //console.log('PAFGINATIONCHECK', productList, totalData);
        if (productList?.length < totalData) {
          GetLoanProducts(currentPage + 1);
          setCurrentPage(currentPage + 1);
        }
      } else {
        return;
      }
    } else {
      if (productList?.length < totalData) {
        GetLoanProducts(currentPage + 1);
        setCurrentPage(currentPage + 1);
      }
    }
  };

  const handleLoanScroll = () => {
    if (
      Math.round(window.innerHeight) +
      Math.round(document.documentElement.scrollTop) !==
      Math.round(document.documentElement.offsetHeight)
    ) {
      if (
        document.documentElement.offsetHeight -
        (window.innerHeight +
          Math.round(document.documentElement.scrollTop)) <=
        1
      ) {
        // //console.log('PAFGINATIONCHECK', loanProductList, loanTotal);
        if (loanProductList?.length < loanTotal) {
          GetLoanProducts(currentPage + 1);
          setCurrentPage(currentPage + 1);
        }
      } else {
        return;
      }
    } else {
      if (loanProductList?.length < loanTotal) {
        GetLoanProducts(currentPage + 1);
        setCurrentPage(currentPage + 1);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [productList]);

  useEffect(() => {
    // //console.log("loanProductList", loanProductList)
    window.addEventListener('scroll', handleLoanScroll);
    return () => window.removeEventListener('scroll', handleLoanScroll);
  }, [loanProductList]);


  const { data: locLoanData } = useQuery(
    ['localLoanData'],
    async () => {
      const LoanData = JSON.parse(localStorage.getItem('loanData'));
      // //console.log(LoanData);
      return LoanData;
    },
    {
      refetchOnWindowFocus: false,
      cacheTime: Number.MAX_SAFE_INTEGER,
    }
  );
  const { isFetching: generFetch, data: generateData } = useQuery(
    [
      'loan-product-search',
      applyFilters,
      queryParams.get('loan'),
      queryParams.get('tenor'),
      queryParams.get('vehTyp'),
      queryParams.get('parfvalue'),
    ],
    async ({ queryKey }) => {
      const postData = {
        ...applyFilters,
        loanamount: queryParams.get('loan'),
        tenure: queryParams.get('tenor'),
        vehicletype:
          queryParams.get('vehTyp') !== 'false'
            ? queryParams.get('vehTyp')
            : '',
        parfvalue:
          queryParams.get('parfvalue') !== 'false' &&
            queryParams.get('vehTyp') === '9ec73f9f-a560-45cd-9e6b-37b126dae58a'
            ? queryParams.get('parfvalue')
            : '',
        loan_application:
          queryParams.get('applicationID') !== undefined &&
            queryParams.get('applicationID') !== 'null'
            ? queryParams.get('applicationID')
            : '',
        bonus: applyFilters?.bonus === 'all' ? '' : applyFilters?.bonus,
        collect_first_installment:
          applyFilters?.collect_first_installment === 'all'
            ? ''
            : applyFilters?.collect_first_installment,
      };
      if (postData?.category !== "") {
        const resp = await axios.post(
          `/loan/product/search/24/${currentPage}`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${authData.token}`,
            },
          }
        );
        //console.log("loan/product/search/", resp.data)
        const product = resp?.data?.data;
        setTotalData(resp.data?.total);
        cartItemsData();
        setProductList(product);
        settopTabCount(resp?.data?.counts?.topFilterCounts);
        return resp?.data?.data;
      }
    },
    {
      refetchOnWindowFocus: false,
      enabled:
        (!!queryParams.get('generate') || !!queryParams.get('appLoan')) &&
        !!settingsData,
    }
  );

  const cartItemsData = async () => {
    const response = await ServerAPI.getCart();
    ////console.log("resp=========", response)
    let selectedItems = [];
    let selectedItemsData = [];
    if (response.data) {
      let items = response.data.items;
      if (items != undefined && items.length > 0) {
        items.map((item) => {
          selectedItems.push({
            product: item.product,
            interest: item.interest,
            is_premium: 1,
            is_manual: 0,
            check: true,
            dealerBonus: '',
          });
          let itemData = { ...item.productinfo };
          itemData['activeinterest'] = item.interestinfo;
          selectedItemsData.push(itemData);
        });
        setselectedLoans(selectedItems);
      }
    }
  };
  const cartItemsDataUpdateSelected = async () => {
    const response = await ServerAPI.getCart();
    //console.log("resp=========2", response)
    let selectedItemsData = [];
    if (response.data) {
      let items = response.data.items;
      if (items != undefined && items.length > 0) {
        items.map((item) => {
          let itemData = { ...item.productinfo };
          itemData['activeinterest'] = item.interestinfo;
          itemData['check'] = true;
          selectedItemsData.push(itemData);
        });
        setSelectedLoanDetails(selectedItemsData);
      }
    }
  };

  // //console.log("selectedLoans", selectedLoans)

  const { isFetching: apLoanLoad, data: apLoanData } = useQuery(
    ['apply-loan', applyFilters, selectedLoans],
    async () => {
      const postData = {
        loanamount: queryParams.get('loan'),
        tenure: queryParams.get('tenor'),
        parfvalue:
          queryParams.get('parfvalue') !== 'false'
            ? queryParams.get('parfvalue')
            : '',
        items: selectedLoans.map((item) => {
          return {
            interest: item.interest,
            product: item.product,
            dealerBonus: '',
          };
        }),
      };
      if (selectedLoans?.length > 0) {
        const resp = await axios.post(`/loan/product/matching/agents`, postData, {
          headers: {
            Authorization: `Bearer ${authData.token}`,
          },
        });

        const product = resp?.data?.data;
        const agentPerfences = resp?.data?.agentPreferences;
        console.log("agentPerfences====", agentPerfences)
        const demOrgData = {};
        Array.from({ length: Object.keys(product).length }).map((_, idx) => {
          const keyName = Object.keys(product)[idx];
          const editObj = product[keyName].map((prodItem) => {
            const activeMerged = agentPerfences
              .map(simplified => {
                const detailed = prodItem.interestData.find(d =>
                  d.agentinfo.id === simplified.agent_id && d.agentinfo.status === 1
                );
                if (!detailed) return null; // skip inactive agents
                return detailed;
              })
              .filter(Boolean);
            console.log("activeMerged====", activeMerged)
            if (0 < activeMerged.length) {

              return {
                ...prodItem,
                defaultAgent: activeMerged[0],
                ['haveAgent']: 1,
                ['activeAgent']: activeMerged[0],
              };
            } else {
              const intData = prodItem.interestData.find((intItem) => {
                if (intItem.hasPremium) {
                  return intItem;
                }
              });
              return {
                ...prodItem,
                defaultAgent: intData,
              };
            }

          });
          demOrgData[keyName] = editObj;
        });
        console.log("demOrgData=====", demOrgData)
        setOrgApplLoanData(demOrgData);
        return demOrgData;
      }
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!settingsData && !!queryParams.get('appLoan') && !!generateData,
    }
  );

  const HandleBonusChange = async (data) => {
    const postData = {
      loanamount: queryParams.get('loan'),
      tenure: queryParams.get('tenor'),
      parfvalue:
        queryParams.get('parfvalue') !== 'false'
          ? queryParams.get('parfvalue')
          : '',
      items: data.map((item) => {
        return {
          interest: item.interest,
          product: item.product,
          dealerBonus: item?.dealerBonus,
        };
      }),
    };
    // //console.log('postData', postData);
    const resp = await axios.post(`/loan/product/matching/agents`, postData, {
      headers: {
        Authorization: `Bearer ${authData.token}`,
      },
    });
    const product = resp?.data?.data;
    const demOrgData = {};
    Array.from({ length: Object.keys(product).length }).map((_, idx) => {
      const keyName = Object.keys(product)[idx];
      const editObj = product[keyName].map((prodItem) => {
        const intData = prodItem.interestData.find((intItem) => {
          if (intItem.hasPremium) {
            return intItem;
          }
        });
        return {
          ...prodItem,
          defaultAgent: intData,
        };
      });
      demOrgData[keyName] = editObj;
    });
    setOrgApplLoanData(demOrgData);
    return demOrgData;
  };

  const HandleReSubmit = async (data) => {
    const postData = {
      ...applyFilters,
      loanamount: data.loan_amt.toString(),
      tenure:
        tenureType === 'year' ? Number(data?.loan_tnr) * 12 : data.loan_tnr,
      vehicletype: data?.vehType,
      parfvalue: data?.min_val,
      loan_application:
        queryParams.get('applicationID') !== undefined &&
          queryParams.get('applicationID') !== 'null'
          ? queryParams.get('applicationID')
          : '',

      bonus: applyFilters?.bonus === 'all' ? '' : applyFilters?.bonus,
      collect_first_installment:
        applyFilters?.collect_first_installment === 'all'
          ? ''
          : applyFilters?.collect_first_installment,
    };
    clearLocalStorageExceptOne('dealerModuleToken');
    localStorage.setItem('filters', JSON.stringify(postData));
    const resp = await axios.post(
      `/loan/product/search/24/${currentPage}`,
      postData,
      {
        headers: {
          Authorization: `Bearer ${authData.token}`,
        },
      }
    );
    const product = resp?.data?.data;
    cartItemsData();
    setProductList(product);
    settopTabCount(resp?.data?.counts?.topFilterCounts);
    return resp?.data?.data;
  };

  // //console.log('orgApplLoanData', orgApplLoanData);

  const handleAgentBonusPop = (agent, bonus) => {
    const popData = {
      ...agent,
      allAgent: bonus,
    };
    // //console.log(popData);
    setallAgentData(popData);
    setbonusPopUp(true);
  };

  const confirmationModalHandler = (value) => {
    setConfirmModal(value);
  };
  const confirmationHandler = (value) => {
    setFilterChangeConfirmation(value);
    if (value == true) {
      setselectedLoans([]);
    }
  };
  const tenureChange = (value) => {
    setTenureType(value);
    setValue('loan_tnr', '');
  };

  const settingsHandle = (idx, title, tabId) => {
    setCurrentPage(1);
    // //console.log('SETTINGSCALLED', idx, title, tabId);
    switch (title) {

      case 'vehicle':
        setSettingsIndex({ ...settingsIndex, veh: idx, typ: 0 });
        setApplyFilters({
          ...applyFilters,
          vehicle: settingsData.vehicles[idx].id,
        });
        dispacth(
          setInitialLoanApplicationFilter({
            ...applyFilters,
            vehicle: settingsData.vehicles[idx].id,
          })
        );

        break;

      case 'category':
        setSettingsIndex({ ...settingsIndex, cat: idx, typ: 0 });
        setApplyFilters({
          ...applyFilters,
          loanType: settingsData.categories[idx].types[0].id,
          scheme: settingsData.categories[idx].types[0].schemes[0].id,
          category: tabId,
          settingIndex: { ...settingsIndex, cat: idx, typ: 0 },
        });
        dispacth(
          setInitialLoanApplicationFilter({
            ...applyFilters,
            loanType: settingsData.categories[idx].types[0].id,
            scheme: settingsData.categories[idx].types[0].schemes[0].id,
            category: tabId,
            settingIndex: { ...settingsIndex, cat: idx, typ: 0 },
          })
        );

        setValue('vehType', settingsData.categories[idx].types[0].id);
        setCatgId(tabId);
        localStorage.setItem('VehicleCategory', tabId);
        setFilterChangeConfirmation(false);
        localStorage.removeItem('title');
        localStorage.removeItem('idx');
        localStorage.removeItem('tabId');
        break;
      case 'type':
        setSettingsIndex({ ...settingsIndex, typ: idx, schm: 0 });
        setApplyFilters({
          ...applyFilters,
          loanType: tabId,
          scheme:
            settingsData?.categories[settingsIndex.cat].types[idx].schemes[0]
              .id,
          settingIndex: { ...settingsIndex, typ: idx, schm: 0 },
        });
        dispacth(
          setInitialLoanApplicationFilter({
            ...applyFilters,
            loanType: tabId,
            scheme:
              settingsData?.categories[settingsIndex.cat].types[idx].schemes[0]
                .id,
            settingIndex: { ...settingsIndex, typ: idx, schm: 0 },
          })
        );
        setFilterChangeConfirmation(false);
        localStorage.setItem('VehicleType', tabId);
        setValue('vehType', tabId);
        localStorage.removeItem('title');
        localStorage.removeItem('idx');
        localStorage.removeItem('tabId');
        break;
      case 'scheme':
        setSettingsIndex({ ...settingsIndex, schm: idx });
        setApplyFilters({
          ...applyFilters,
          loanType:
            settingsData?.categories[settingsIndex.cat].types[settingsIndex.typ]
              .id,
          scheme: tabId,
          settingIndex: { ...settingsIndex, schm: idx },
        });
        dispacth(
          setInitialLoanApplicationFilter({
            ...applyFilters,
            loanType:
              settingsData?.categories[settingsIndex.cat].types[
                settingsIndex.typ
              ].id,
            scheme: tabId,
            settingIndex: { ...settingsIndex, schm: idx },
          })
        );
        break;
      case 'motor':
        setApplyFilters({
          ...applyFilters,
          motorType: tabId,
        });
        dispacth(
          setInitialLoanApplicationFilter({
            ...applyFilters,
            motorType: tabId,
          })
        );
        break;
      case 'usage':
        setApplyFilters({
          ...applyFilters,
          usage: tabId,
        });
        dispacth(
          setInitialLoanApplicationFilter({
            ...applyFilters,
            usage: tabId,
          })
        );
        break;
      case 'approval time':
        setApplyFilters({
          ...applyFilters,
          approvalTime: tabId === null ? '' : tabId,
        });
        dispacth(
          setInitialLoanApplicationFilter({
            ...applyFilters,
            approvalTime: tabId === null ? '' : tabId,
          })
        );
        break;
      case 'loan to value':
        setApplyFilters({
          ...applyFilters,
          ltv: tabId === null ? '' : tabId,
        });
        dispacth(
          setInitialLoanApplicationFilter({
            ...applyFilters,
            ltv: tabId === null ? '' : tabId,
          })
        );
        break;
      case 'bonus':
        setApplyFilters({
          ...applyFilters,
          bonus: tabId,
        });
        dispacth(
          setInitialLoanApplicationFilter({
            ...applyFilters,
            bonus: tabId,
          })
        );
        break;
      case 'collect first installment?':
        setApplyFilters({
          ...applyFilters,
          collect_first_installment: tabId,
        });
        dispacth(
          setInitialLoanApplicationFilter({
            ...applyFilters,
            collect_first_installment: tabId,
          })
        );
        break;
      default:
        break;
    }
  };
  // //console.log('APPLYIDDDDFILTERS', queryParams.get('applicationID'));
  const handleSwitchButton = () => {
    setSwitchButton(!switchButton);
    setApplyFilters({
      ...applyFilters,
      toggleSwitch: switchButton ? 'ht' : 'lt',
    });
    dispacth(
      setInitialLoanApplicationFilter({
        ...applyFilters,
        toggleSwitch: switchButton ? 'ht' : 'lt',
      })
    );
  };
  const genData = (data) => {
    // //console.log(tenureType);
    let tenure = '';
    if (tenureType == 'year') {
      tenure = data.loan_tnr * 12;
    } else if (tenureType == 'month') {
      tenure = data.loan_tnr;
    }
    const postData = {
      ...applyFilters,
      loanamount: data.loan_amt.toString(),
      tenure:
        tenureType === 'year' ? Number(data?.loan_tnr) * 12 : data.loan_tnr,
      vehicletype: data?.vehType,
      parfvalue: data?.min_val,
      loan_application:
        queryParams.get('applicationID') !== undefined &&
          queryParams.get('applicationID') !== 'null'
          ? queryParams.get('applicationID')
          : '',

      bonus: applyFilters?.bonus === 'all' ? '' : applyFilters?.bonus,
      collect_first_installment:
        applyFilters?.collect_first_installment === 'all'
          ? ''
          : applyFilters?.collect_first_installment,
    };
    clearLocalStorageExceptOne('dealerModuleToken');
    localStorage.setItem('filters', JSON.stringify(postData));
    navigate(
      `${location.pathname}?generate=true&loan=${data.loan_amt
      }&tenor=${tenure}&vehTyp=${vehType ? vehType : 'false'}&parfvalue=${data.min_val ? data.min_val : 'false'
      }&tnr_type=${tenureType}&applicationID=${queryParams.get(
        'applicationID'
      )}`,
      { state: pagePermission }
    );
    window.scrollTo({ top: 0 });
  };
  const handleApplyLoan = () => {
    const { loan_amt, loan_tnr, min_val } = getValues();
    // navigate(
    //   `${location.pathname}?appLoan=true&loan=${loan_amt}&tenor=${tenureType == 'year' ? loan_tnr * 12 : loan_tnr
    //   }&vehTyp=${vehType ? vehType : 'false'}&parfvalue=${min_val ? min_val : 'false'
    //   }&&tnr_type=${tenureType}&applicationID=${queryParams.get(
    //     'applicationID'
    //   )}`
    // );

    const url = `${location.pathname}?appLoan=true&loan=${loan_amt}&tenor=${tenureType == 'year' ? loan_tnr * 12 : loan_tnr
      }&vehTyp=${vehType ? vehType : 'false'}&parfvalue=${min_val ? min_val : 'false'
      }&&tnr_type=${tenureType}&applicationID=${queryParams.get(
        'applicationID'
      )}`;
    localStorage.setItem("loanQueryUrl", `${location.pathname}?generate=true&loan=${loan_amt}&tenor=${tenureType == 'year' ? loan_tnr * 12 : loan_tnr
      }&vehTyp=${vehType ? vehType : 'false'}&parfvalue=${min_val ? min_val : 'false'
      }&&tnr_type=${tenureType}&applicationID=${queryParams.get(
        'applicationID'
      )}`);
    navigate(url);
    window.scrollTo({ top: 0 });
  };
  const handleLoanList = () => {
    // //console.log(
    //   'SELECTEDLOANS',
    //   selectedLoans?.map((it) => it?.check),
    //   selectedLoanDetails
    // );
    setselectedLoans(
      [...selectedLoans].filter((obj) => {
        if (obj.check === true) {
          return obj;
        }
      })
    );
    setSelectedLoanDetails(
      [...selectedLoanDetails].filter((obj) => {
        if (obj.check === true) {
          return obj;
        }
      })
    );
    setviewLoan(false);
  };
  const handleNewLoanApply = async () => {
    let agentErr = 0;
    // //console.log('orgApplLoanData', orgApplLoanData);
    Array.from({ length: Object.keys(orgApplLoanData).length }).map(
      (_, idx) => {
        const keyName = Object.keys(orgApplLoanData)[idx];
        orgApplLoanData[keyName].map((item) => {
          if (!item.activeAgent) {
            agentErr++;
          }
          if (item.defaultAgent) {
            agentErr--;
          }
        });
      }
    );
    if (agentErr > 0) {
      toast.error('Please Choose Agent for each product', {
        position: 'top-right',
      });
    } else {
      let items = [];
      let loanCreationData = {};
      let loanApplicationData = orgApplLoanData;

      let filterData = JSON.parse(localStorage.getItem('filters'));
      // //console.log('FILTERDATA', filterData);
      loanCreationData['loanamount'] = filterData.loanamount;
      loanCreationData['tenure'] = filterData.tenure;
      loanCreationData['parfvalue'] = filterData.parfvalue
        ? filterData.parfvalue
        : '0.00';
      loanCreationData['category'] = filterData.category;
      loanCreationData['loanType'] = filterData.loanType;
      loanCreationData['loanfor'] = '';
      loanCreationData['loan_application'] =
        queryParams.get('applicationID') !== undefined &&
          queryParams.get('applicationID') !== 'null'
          ? queryParams.get('applicationID')
          : '';
      if (Object.keys(loanApplicationData).length > 0) {
        if (loanApplicationData['Bank'].length > 0) {
          let bankData = loanApplicationData['Bank'];
          bankData.map((bank) => {
            // //console.log('BANK', bank);
            if (bank['activeAgent'] && bank['activeinterest']) {
              let activeData = bank['activeAgent'];
              let activeInterest = bank['activeinterest'];
              items.push({
                product: activeData.agentcommisioninfo.product,
                interest: activeInterest.id,
                agentcommision: activeData.agentcommisioninfo.id,
                adminfee: activeData.adminfeeinfo
                  ? activeData.adminfeeinfo.id
                  : 0,
                selected_year: activeData.selected_year,
                dealerbonus: selectedBonus[bank['id']],
              });
            } else if (bank['defaultAgent'] && bank['activeinterest']) {
              let activeData = bank['defaultAgent'];
              let activeInterest = bank['activeinterest'];
              items.push({
                product: activeData.agentcommisioninfo.product,
                interest: activeInterest.id,
                agentcommision: activeData.agentcommisioninfo.id,
                adminfee: activeData.adminfeeinfo
                  ? activeData.adminfeeinfo.id
                  : 0,
                selected_year: activeData.selected_year,
                dealerbonus: selectedBonus[bank['id']],
              });
            }
          });
        }
        if (loanApplicationData['Financial Institution'].length > 0) {
          let bankData = loanApplicationData['Financial Institution'];
          bankData.map((bank) => {
            if (bank['activeAgent'] && bank['activeinterest']) {
              let activeData = bank['activeAgent'];
              let activeInterest = bank['activeinterest'];
              items.push({
                product: activeData.agentcommisioninfo.product,
                interest: activeInterest.id,
                agentcommision: activeData.agentcommisioninfo.id,
                adminfee: activeData.adminfeeinfo
                  ? activeData.adminfeeinfo.id
                  : 0,
                selected_year: activeData.selected_year,
                dealerbonus: selectedBonus[bank['id']],
              });
            } else if (bank['defaultAgent'] && bank['activeinterest']) {
              let activeData = bank['defaultAgent'];
              let activeInterest = bank['activeinterest'];
              items.push({
                product: activeData.agentcommisioninfo.product,
                interest: activeInterest.id,
                agentcommision: activeData.agentcommisioninfo.id,
                adminfee: activeData.adminfeeinfo
                  ? activeData.adminfeeinfo.id
                  : 0,
                selected_year: activeData.selected_year,
                dealerbonus: selectedBonus[bank['id']],
              });
            }
          });
        }
        if (loanApplicationData['In-House'].length > 0) {
          let bankData = loanApplicationData['In-House'];
          bankData.map((bank) => {
            let activeInterest = bank['activeinterest'];
            if (bank['activeAgent'] && activeInterest) {
              let activeData = bank['activeAgent'];
              items.push({
                product: activeData.agentcommisioninfo.product,
                interest: activeInterest.id,
                agentcommision: activeData.agentcommisioninfo.id,
                adminfee: activeData.adminfeeinfo.id,
                selected_year: activeData.selected_year,
                dealerbonus: selectedBonus[bank['id']],
              });
            } else if (bank['defaultAgent'] && bank['activeinterest']) {
              let activeData = bank['defaultAgent'];
              let activeInterest = bank['activeinterest'];
              items.push({
                product: activeData.agentcommisioninfo.product,
                interest: activeInterest.id,
                agentcommision: activeData.agentcommisioninfo.id,
                adminfee: activeData.adminfeeinfo
                  ? activeData.adminfeeinfo.id
                  : 0,
                selected_year: activeData.selected_year,
                dealerbonus: selectedBonus[bank['id']],
              });
            }
          });
        }
      }
      loanCreationData['items'] = items?.map((it) => {
        return {
          ...it,
          dealerbonus:
            it?.dealerbonus == undefined || it?.dealerbonus == null
              ? ''
              : it?.dealerbonus,
        };
      });
      // //console.log('LOAN CREATION', loanCreationData);
      try {
        setLoading(true);
        const response = await ServerAPI.createLoan(loanCreationData);
        if (response) {
          localStorage.setItem('applicationId', response.data?.id);
          localStorage.setItem('applicationno', response.data.id);
          setLoading(false);
          if (
            queryParams.get('applicationID') !== undefined &&
            queryParams.get('applicationID') !== 'null'
          ) {
            navigate('/case-detail', {
              state: {
                Id: queryParams.get('applicationID'),
                pagePermission: pagePermission,
              },
            });
          } else {
            navigate(`/loan-apply/${response.data.id}`, {
              state: loanCreationData,
            });
          }
        }
      } catch (err) {
        setLoading(false);
      }
      window.scrollTo({ top: 0 });
    }
  };
  useEffect(() => {
    if (settingsData) {
      if (Number(minParfVal) > 0) {
        setApplyFilters({
          ...applyFilters,
          scheme:
            settingsData.categories[settingsIndex.cat].types[settingsIndex.typ]
              .schemes[1].id,
        });
      } else {
        setApplyFilters({
          ...applyFilters,
          scheme:
            settingsData.categories[settingsIndex.cat].types[settingsIndex.typ]
              .schemes[0].id,
        });
      }
      setApplyFilters({
        ...applyFilters,
        scheme:
          queryParams.get('parfvalue') !== '' &&
            queryParams.get('parfvalue') !== null &&
            queryParams.get('parfvalue') !== 'false'
            ? settingsData.categories[0].types[0].schemes[1].id
            : settingsData.categories[0].types[0].schemes[0].id,
      });
    }
  }, [queryParams.get('parfvalue')]);

  useEffect(() => {
    if (filterChangeConfirmation == true) {
      if (localStorage.getItem('title') == 'type') {
        setSelectedValue(localStorage.getItem('tabId'));
        settingsHandle(
          localStorage.getItem('idx'),
          localStorage.getItem('title'),
          localStorage.getItem('tabId')
        );
      } else {
        settingsHandle(
          localStorage.getItem('idx'),
          localStorage.getItem('title'),
          localStorage.getItem('tabId')
        );
      }
    }
  }, [filterChangeConfirmation]);

  useEffect(() => {
    if (queryParams.get('loan')) {
      setValue('loan_amt', queryParams.get('loan'));
    }
    if (queryParams.get('tnr_type')) {
      setTenureType(queryParams.get('tnr_type'));
    }
    if (queryParams.get('tenor')) {
      let tenure = '';
      // //console.log(typeof queryParams.get('tnr_type'));
      if (queryParams.get('tnr_type') == 'year') {
        setValue('loan_tnr', queryParams.get('tenor') / 12);
        tenure = parseInt(queryParams.get('tenor')) * 12;
      } else {
        tenure = queryParams.get('tenor');
        setValue('loan_tnr', tenure);
      }
    }
    if (
      queryParams.get('vehTyp') !== 'false' &&
      queryParams.get('vehTyp') !== null
    ) {
      // //console.log(
      //   'GETVEHICLETYPE',
      //   queryParams.get('vehTyp'),
      //   applyFilters?.loanType
      // );
      setValue(
        'vehType',
        applyFilters?.loanType !== ''
          ? applyFilters?.loanType
          : queryParams.get('vehTyp')
      );
    }
    if (queryParams.get('parfvalue') !== 'false') {
      setValue('min_val', queryParams.get('parfvalue'));
    }
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (location.search == '') {
      clearLocalStorageExceptOne('dealerModuleToken');
      clearCart();
    }
  }, [location]);

  useEffect(() => {
    cartItemsData();
  }, []);

  const clearCart = async () => {
    const response = await ServerAPI.RemoveCart();
    if (response) {
    }
  };
  useEffect(() => {
    // if (selectedLoans != undefined && selectedLoans.length > 0) {
    // }
    cartItemsDataUpdateSelected();
  }, []);
  useEffect(() => {
    // //console.log('MINOPARFarfVal', totalData);
  }, [watch()]);
  //selectedLoans

  if (isLoading) {
    return <PageLoader />;
  }

  if (queryParams.get('generate')) {
    return (
      <div className=' w-full min-h-screen bg-[#F5F5F5] overflow-x-clip loan-proof'>
        <ViewBonusPopup
          bonusPopUp={bonusPopUp}
          bonusData={allAgentData}
          closeBonusPop={() => setbonusPopUp(false)}
        />
        <Modal
          title='Selected Loan Product'
          className='sel_loan_pop'
          open={viewLoan}
          closeIcon={false}
          okText='Confirm'
          cancelText='Cancel'
          onCancel={() => setviewLoan(false)}
          onOk={handleLoanList}
        >
          {selectedLoanDetails != undefined &&
            selectedLoanDetails.length > 0 &&
            selectedLoanDetails.map((item, idx) => {
              if (item != undefined) {
                let check = item.check;
                const actInt = item.activeinterest;
                return (
                  <label
                    key={idx}
                    className='flex items-center gap-[10px_15px] mb-[11px] rounded-[8px] bg-white border border-[#E0E0E0] p-[10px] cursor-pointer'
                    htmlFor={`loanCheck${idx}`}
                  >
                    <div>
                      <Checkbox
                        id={`loanCheck${idx}`}
                        checked={check}
                        onChange={() => {
                          // //console.log(
                          //   'ONCHANGE VALUES',
                          //   item.id,
                          //   selectedLoans
                          // );
                          setselectedLoans(
                            [...selectedLoans].map((obj) => {
                              if (obj.product === item.id) {
                                return {
                                  ...obj,
                                  check: !check,
                                };
                              } else {
                                return obj;
                              }
                            })
                          );
                          setSelectedLoanDetails(
                            [...selectedLoanDetails].map((obj) => {
                              if (obj.id === item.id) {
                                return {
                                  ...obj,
                                  check: !check,
                                };
                              } else {
                                return obj;
                              }
                            })
                          );
                        }}
                      />
                    </div>
                    <div className='w-[70px] h-[70px] bg-[white] rounded-[4px] border border-[#E0E0E0]'>
                      <img
                        src={`${IMAGE_BASE_URL}/${item.icon}`}
                        alt='logo'
                        className='w-full h-full object-cover rounded-[4px]'
                      />
                    </div>
                    <div className='flex-[1] text-[#27272B] font-bold text-[15px]'>
                      {item.name}
                      <div className='flex flex-wrap items-center gap-[4px] mt-[5px]'>
                        {item.hasPremium ? (
                          <span className='inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500] w-[95px] mr-[10px]'>
                            <img
                              src='/images/prem_icon.svg'
                              className='w-[16px]'
                              alt='star'
                            />{' '}
                            <span className='relative top-[1px]'>Premium</span>
                          </span>
                        ) : null}
                        {item.featured ? (
                          <span className='inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500] w-[95px]'>
                            <img
                              src='/images/star.svg'
                              className='w-[16px]'
                              alt='star'
                            />{' '}
                            <span className='relative top-[1px]'>Featured</span>
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className='min-w-[71px]'>
                      <span className='block text-[22px] font-[800]'>
                        {actInt.interest}%
                      </span>
                      {/* <span className="block text-[13px] text-[#0F59F9]">Bonus ({item[0].interests[0]?.allagentbonuses ? item[0].interests[0].allagentbonuses?.length : 0})</span> */}
                    </div>
                  </label>
                );
              }
            })}
        </Modal>
        {selectedLoans.length > 0 && (
          <div className='z-10 bt_floater fixed bottom-[20px] left-[0px] m-2 right-0'>
            <div className='w-[90%] sm:w-[100%] flex-wrap max-w-[800px] bg-[#2F2F2F] rounded-[16px] mx-auto flex justify-between items-center p-[12px_15px] text-white text-[15px]'>
              <div className='w-full md:w-auto font-[600] md:text-left text-center'>
                You’re applying loan for ({selectedLoans.length}) Loan products
                <span
                  className='ml-[10px] font-[500] text-[#5795FF] cursor-pointer'
                  onClick={() => setviewLoan(true)}
                >
                  view selected
                </span>
              </div>
              <div className='w-full flex justify-center md:w-auto'>
                <Button
                  className='floater_btn wh mr-[15px]'
                  onClick={() => {
                    setselectedLoans([]);
                    clearCart();
                  }}
                >
                  Clear Selected
                </Button>
                <Button
                  type='primary'
                  className='floater_btn capitalize'
                  onClick={handleApplyLoan}
                >
                  Apply Loan for all
                </Button>
              </div>
            </div>
          </div>
        )}
        <form onSubmit={handleSubmit(HandleReSubmit)}>
          <div className='bg-white'>
            <div className='text-[20px] font-[700] p-[18px_25px] bg-white'>
              New Loan Application
              <ConfirmationModal
                close={() => {
                  setConfirmModal(false);
                }}
                open={confirmModal}
                updateHandler={confirmationHandler}
              />
            </div>
            <div className='flex items-center justify-between gap-[15px] px-[25px] mb-[20px] max-[600px]:flex-wrap'>
              <div className='w-[340px] max-w-full max-[600px]:w-full'>
                <Controller
                  control={control}
                  name='loan_amt'
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <InputNumber
                        {...field}
                        status={fieldState.error ? 'error' : null}
                        type='number'
                        className='genrate_inp w-full'
                        addonBefore={
                          <FiDollarSign color='white' fontSize={18} />
                        }
                        placeholder='Loan Amount'
                      />
                    );
                  }}
                />
              </div>
              <div className='w-[340px] max-w-full max-[600px]:w-full'>
                <Controller
                  control={control}
                  name='loan_tnr'
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <InputNumber
                        {...field}
                        status={fieldState.error ? 'error' : null}
                        type='number'
                        min={tenureType === 'year' ? 1 : 12}
                        max={tenureType === 'year' ? 10 : 120}
                        className='genrate_inp w-full tenure-container'
                        addonBefore={<FiCalendar color='white' fontSize={18} />}
                        placeholder={`${tenureType === 'year'
                          ? 'Loan Tenor (Max. 10)'
                          : 'Loan Tenor (Max. 120)'
                          }`}
                        addonAfter={
                          <Select
                            value={tenureType}
                            onChange={tenureChange}
                            style={{
                              width: 100,
                            }}
                            bordered={false}
                            options={[
                              {
                                value: 'year',
                                label: 'Year',
                              },
                              {
                                value: 'month',
                                label: 'Month',
                              },
                            ]}
                          />
                        }
                      />
                    );
                  }}
                />
              </div>
              <div className='w-[340px] max-w-full max-[600px]:w-full relative'>
                <div className='absolute h-full w-full flex items-center justify-end z-[2] pointer-events-none'>
                  <img
                    src='/images/select_ar.svg'
                    className='mr-[13px] mt-[3px]'
                    alt='arrow'
                    width='12'
                    height='12'
                  />
                </div>
                <Controller
                  control={control}
                  name='vehType'
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <Select
                        {...field}
                        status={fieldState.error ? 'error' : null}
                        placeholder='Vehicle Type'
                        className='w-full veh_selct min-h-[50px]'
                        suffixIcon={
                          <span className='custom_prefix_sel'>
                            <FaCarSide color='white' fontSize={18} />
                          </span>
                        }
                        options={settingsData.categories[
                          settingsIndex.cat
                        ].types.map((item, idx) => {
                          return {
                            label: item.name,
                            value: item.id,
                            id: idx,
                          };
                        })}
                        onChange={(e) => {
                          let index = localStorage.getItem('idx');
                          let data = JSON.parse(
                            localStorage.getItem('loanData')
                          );
                          // //console.log('data', data);
                          if (index) {
                            if (index == 0) {
                              localStorage.setItem('idx', 1);
                            } else if (index == 1) {
                              localStorage.setItem('idx', 0);
                            }
                          } else {
                            localStorage.setItem('idx', 0);
                          }
                          localStorage.setItem('title', 'type');
                          localStorage.setItem('tabId', e);
                          setConfirmModal(true);
                          // if (data != undefined && data.length > 0) {
                          //   setConfirmModal(true);
                          // } else {
                          //   confirmationHandler(true);
                          // }
                          field.onChange(e);
                          setValue('min_val', '');
                        }}
                      />
                    );
                  }}
                />
              </div>
              <div className='w-[340px] max-w-full max-[600px]:w-full'>
                <Controller
                  control={control}
                  name='min_val'
                  render={({ field }) => {
                    return (
                      <InputNumber
                        {...field}
                        type='number'
                        className={`genrate_inp w-full ${vehType === '3ae152dc-c962-49e5-a4d4-481c5a3c2743' &&
                          'cusInpDis'
                          }`}
                        addonBefore={
                          <FiDollarSign color='white' fontSize={18} />
                        }
                        placeholder='Min. PARF Value'
                        disabled={
                          vehType === '3ae152dc-c962-49e5-a4d4-481c5a3c2743'
                        }
                        onChange={(val) => {
                          // //console.log('min_val', val);
                          setValue('min_val', val);
                          setApplyFilters({
                            ...applyFilters,
                            scheme:
                              settingsData?.categories[0]?.types[0]?.schemes[
                                val !== null && val !== '' ? 1 : 0
                              ]?.id,
                          });
                          dispacth(
                            setInitialLoanApplicationFilter({
                              ...applyFilters,
                              scheme:
                                settingsData?.categories[0]?.types[0]?.schemes[
                                  val !== null && val !== '' ? 1 : 0
                                ]?.id,
                            })
                          );
                        }}
                      />
                    );
                  }}
                />
              </div>
              <div className='max-[600px]:w-full w-auto text-center'>
                {pagePermission?.create_permission == 1 && (
                  <ButtonBase
                    type='submit'
                    disabled={
                      !vehType && minParfVal !== '' && minParfVal !== null
                    }
                  >
                    <div className='inline-block text-[18px] font-[600] rounded-[5px] p-[11.5px_34px] bg-[#0560FB] text-white'>
                      Generate
                    </div>
                  </ButtonBase>
                )}
              </div>
            </div>
            {vehType !== '3ae152dc-c962-49e5-a4d4-481c5a3c2743' ? (
              <div>
                {!vehType && minParfVal !== '' && minParfVal !== null ? (
                  <div className='text-[14px] ml-auto text-[red] font-[500] w-[500px] max-w-full max-[600px]:w-full max-[600px]:order-2'>
                    Fill up VEHICLE TYPE first, then ARF Paid(PARF Eligible
                    Vehicles) for balloon scheme monthly installment
                  </div>
                ) : (
                  <div className='flex items-center justify-center flex-wrap gap-[0_7px] text-[14px] font-[500] mr-[25px] max-[600px]:w-full'>
                    Fill up Min. PARF value for
                    <a className='text-[#0560FB] cursor-pointer'>
                      BALLOON SCHEME
                    </a>{' '}
                    <span>
                      installment
                      <Popover content={schemeContent}>
                        <img
                          src='/images/fi_info.svg'
                          alt='info'
                          className='inline-block ml-[4px] cursor-pointer'
                        />
                      </Popover>
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <div className='text-[14px] font-[500] text-center mt-[20px] pr-[25px]'>
                <a className='text-[#0560FB] cursor-pointer mr-[6px] my-[25px]'>
                  BALLOON SCHEME
                </a>
                not applicable for COE vehicle type
              </div>
            )}
            <Tabs
              className='mt-[8px]'
              id='loan_appl_tab'
              activeKey={tabActiveKey}
              onChange={(key) => {
                settabActiveKey(key);
                delete applyFilters[topTabCount[tabActiveKey].parameter];
                const { parameter, value } = topTabCount[key];
                setApplyFilters({
                  ...applyFilters,
                  index: key,
                  [parameter]: value,
                });
                dispacth(
                  setInitialLoanApplicationFilter({
                    ...applyFilters,
                    index: key,
                    [parameter]: value,
                  })
                );
              }}
              items={topTabCount.map((item, idx) => {
                return {
                  label: `${item.label} (${item.count})`,
                  key: idx,
                };
              })}
            />
          </div>
        </form>
        <div className='flex gap-[20px] p-[30px] mob-flex-col items-start'>
          <div className='bg-white side-banner max-w-full bg-white ln_ap_shad2 rounded-[4px] p-[20px_30px] top-0'>
            <LnSwitchBox
              title='Vehicle'
              tabs={settingsData.vehicles}
              settingsHandler={confirmationModalHandler}
              value={applyFilters?.vehicle}
              confirmationModalHandler={confirmationModalHandler}
              confirmationHandler={confirmationHandler}
              cartRefresher={cartItemsData}
            />{' '}
            <br />
            <LnSwitchBox
              title='Category'
              tabs={settingsData.categories}
              settingsHandler={confirmationModalHandler}
              value={applyFilters?.category}
              confirmationModalHandler={confirmationModalHandler}
              confirmationHandler={confirmationHandler}
              cartRefresher={cartItemsData}
            />{' '}
            <br />
            <LnSwitchBox
              title='Type'
              tabs={settingsData.categories[settingsIndex.cat].types}
              settingsHandler={confirmationModalHandler}
              confirmationModalHandler={confirmationModalHandler}
              value={applyFilters.loanType}
              confirmationHandler={confirmationHandler}
              cartRefresher={cartItemsData}
            />
            <LnSwitchBox
              title='Scheme'
              tabs={
                settingsData.categories[settingsIndex.cat].types[
                  settingsIndex.typ
                ].schemes
              }
              settingsHandle={settingsHandle}
              value={applyFilters.scheme}
              disab={minParfVal > 0 ? false : true}
            />
            <LnSwitchBox
              title='Motor'
              tabs={settingsData.productMotorTypes}
              settingsHandle={settingsHandle}
              value={applyFilters.motorType}
            />
            <LnSwitchBox
              title='Usage'
              tabs={settingsData.productUsages}
              settingsHandle={settingsHandle}
              value={applyFilters.usage}
            />
            <br />
            <LnSwitchBox
              title='Approval Time'
              tabs={settingsData.approvalTimes}
              info='info'
              settingsHandle={settingsHandle}
              value={applyFilters.approvalTime}
            />
            <LnSwitchBox
              title='Loan to Value'
              tabs={settingsData.ltvs}
              info='info'
              settingsHandle={settingsHandle}
              value={applyFilters.ltv}
            />
            <BonusSwitchBox
              title='Bonus'
              tabs={[
                { name: 'All', val: 'all' },
                { name: 'Yes', val: '1' },
                { name: 'No', val: '0' },
              ]}
              info='info'
              settingsHandle={settingsHandle}
              value={applyFilters.bonus}
            />
            <BonusSwitchBox
              title='Collect First Installment?'
              tabs={[{ name: 'All', val: 'all' }].concat(
                settingsData.collect_first_installment_options?.map((it) => {
                  return {
                    ...it,
                    val: it.value,
                  };
                })
              )}
              info='info'
              settingsHandle={settingsHandle}
              value={applyFilters.collect_first_installment}
            />
            <div className='mt-[7px]'>
              <IntSwitchButton
                noFloat
                switchVal={switchButton}
                handleSwitchButton={handleSwitchButton}
              />
            </div>
          </div>
          <div className='flex flex-col flex-[1] gap-[50px_10px] w-full' style={{ width: "calc(100% - 400px)" }}>
            {generFetch ? (
              <LoaderComp />
            ) : (
              <>
                {productList?.length > 0 ? (
                  productList?.map((item, idx) => {
                    return (

                      <LongBankCard
                        indexData={idx}
                        key={idx}
                        product={item}
                        interestSort={switchButton ? 0 : 1}
                        allAgentBonus={handleAgentBonusPop}
                        loanContext={{ selectedLoans, setselectedLoans }}
                        SelectedLoanDetails={{ setSelectedLoanDetails }}
                      />
                    );
                  })
                ) : (
                  <h3 className='text-center w-full text-[24px] font-bold'>
                    No Products
                  </h3>
                )}
              </>
            )}
          </div >
        </div>
      </div>
    );
  }
  if (queryParams.get('appLoan')) {
    return (

      <>
        {selAgentPop && (
          <SelAgentPopup
            context={{
              selAgentPop,
              setselAgentPop,
              selectedAgent,
              setSelectedAgent,
              updateChosedAgent,
            }}
          />
        )}
        {apLoanLoad || generFetch ? (
          <LoaderComp />
        ) : (
          <div className='w-full min-h-screen bg-[#F5F5F5] overflow-x-clip'>
            <Modal
              title='Selected Loan Product'
              className='sel_loan_pop'
              open={viewLoan}
              closeIcon={false}
              okText='Confirm'
              cancelText='Cancel'
              onCancel={() => setviewLoan(false)}
              onOk={handleLoanList}
            >
              {/* {//console.log(selectedLoanDetails)} */}
              {selectedLoanDetails != undefined &&
                selectedLoanDetails.length > 0 &&
                selectedLoanDetails.map((item, idx) => {
                  if (item != undefined) {
                    // //console.log(item);
                    let check = item.check;
                    const actInt = item.activeinterest;
                    // //console.log(actInt);
                    return (
                      <label
                        key={idx}
                        className='flex items-center gap-[10px_15px] mb-[11px] rounded-[8px] bg-white border border-[#E0E0E0] p-[10px] cursor-pointer'
                        htmlFor={`loanCheck${idx}`}
                      >
                        <div>
                          <Checkbox
                            id={`loanCheck${idx}`}
                            checked={check}
                            onChange={() =>
                              setselectedLoans(
                                [...selectedLoans].map((obj) => {
                                  if (obj.id === item.id) {
                                    return {
                                      ...obj,
                                      check: !check,
                                    };
                                  } else {
                                    return obj;
                                  }
                                })
                              )
                            }
                          />
                        </div>
                        <div className='w-[70px] h-[70px] bg-[white] rounded-[4px] border border-[#E0E0E0]'>
                          <img
                            src={`${IMAGE_BASE_URL}/${item.icon}`}
                            alt='logo'
                            className='w-full h-full object-cover rounded-[4px]'
                          />
                        </div>
                        <div className='flex-[1] text-[#27272B] font-bold text-[15px]'>
                          {item.name}
                          <div className='flex flex-wrap items-center gap-[4px] mt-[5px]'>
                            {item.hasPremium ? (
                              <span className='inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500] mr-[10px]'>
                                <img
                                  src='/images/prem_icon.svg'
                                  className='w-[16px]'
                                  alt='star'
                                />{' '}
                                <span className='relative top-[1px]'>
                                  Premium
                                </span>
                              </span>
                            ) : null}
                            {item.featured ? (
                              <span className='inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500]'>
                                <img
                                  src='/images/star.svg'
                                  className='w-[16px]'
                                  alt='star'
                                />{' '}
                                <span className='relative top-[1px]'>
                                  Featured
                                </span>
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className='min-w-[71px]'>
                          <span className='block text-[22px] font-[800]'>
                            {actInt.interest}%
                          </span>
                          {/* <span className="block text-[13px] text-[#0F59F9]">Bonus ({item[0].interests[0]?.allagentbonuses ? item[0].interests[0].allagentbonuses?.length : 0})</span> */}
                        </div>
                      </label>
                    );
                  }
                })}
            </Modal>
            {selectedLoans.length > 0 && (
              <div className='z-50 bt_floater fixed bottom-[20px] left-[0px] m-2 right-0'>
                {/* {//console.log('FINAL', selectedLoans, selectedBonus)} */}
                <div className='max-w-[650px] w-[90%] gap-4 flex-wrap bg-[#2F2F2F] rounded-[16px] mx-auto flex justify-between items-center p-[12px_15px] text-white text-[15px]'>
                  <div className='w-full md:w-auto font-[600] text-center md:text-left'>
                    You’re applying loan for ({selectedLoans.length}) Loan
                    products
                  </div>
                  <div className='w-full md:w-auto flex justify-center'>
                    <Button
                      onClick={handleNewLoanApply}
                      loading={loading}
                      type='primary'
                      className='floater_btn capitalize'
                      style={{
                        background: !(
                          selectedLoans?.length ==
                          Object.keys(selectedBonus)?.length
                        )
                          ? '#1677ff'
                          : '',
                        color: !(
                          selectedLoans?.length ==
                          Object.keys(selectedBonus)?.length
                        )
                          ? 'white'
                          : '',
                        border: 'none',
                      }}
                    // disabled={
                    //   !(
                    //     selectedLoans?.length ==
                    //     Object.keys(selectedBonus)?.length
                    //   )
                    // }
                    >
                      Apply Loan for all
                    </Button>
                  </div>
                </div>
              </div>
            )}
            <form onSubmit={handleSubmit(genData)}>
              <div className='bg-white'>
                <div className='text-[20px] font-[700] p-[18px_25px] bg-white'>
                  New Loan Application
                </div>
                <div className='flex items-center justify-between gap-[15px] px-[25px] pb-[20px] max-[600px]:flex-wrap'>
                  <div className='w-[340px] max-w-full max-[600px]:w-full'>
                    <Controller
                      control={control}
                      name='loan_amt'
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <InputNumber
                            {...field}
                            status={fieldState.error ? 'error' : null}
                            type='number'
                            className='genrate_inp w-full cusInpDis'
                            addonBefore={
                              <FiDollarSign color='white' fontSize={18} />
                            }
                            placeholder='Loan Amount'
                            readOnly
                          />
                        );
                      }}
                    />
                  </div>
                  <div className='w-[340px] max-w-full max-[600px]:w-full'>
                    <Controller
                      control={control}
                      name='loan_tnr'
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <InputNumber
                            {...field}
                            status={fieldState.error ? 'error' : null}
                            type='number'
                            min={tenureType === 'year' ? 1 : 12}
                            max={tenureType === 'year' ? 10 : 120}
                            className='genrate_inp w-full cusInpDis tenure-container'
                            addonBefore={
                              <FiCalendar color='white' fontSize={18} />
                            }
                            placeholder={`${tenureType === 'year'
                              ? 'Loan Tenor (Max. 10)'
                              : 'Loan Tenor (Max. 120)'
                              }`}
                            addonAfter={
                              <Select
                                disabled={true}
                                defaultValue={tenureType}
                                onChange={tenureChange}
                                style={{
                                  width: 100,
                                }}
                                bordered={false}
                                options={[
                                  {
                                    value: 'year',
                                    label: 'Year',
                                  },
                                  {
                                    value: 'month',
                                    label: 'Month',
                                  },
                                ]}
                              />
                            }
                            readOnly
                          />
                        );
                      }}
                    />
                  </div>
                  <div className='w-[340px] max-w-full max-[600px]:w-full relative'>
                    <div className='absolute h-full w-full flex items-center justify-end z-[2] pointer-events-none'>
                      <img
                        src='/images/select_ar.svg'
                        className='mr-[13px] mt-[3px]'
                        alt='arrow'
                        width='12'
                        height='12'
                      />
                    </div>
                    <Controller
                      control={control}
                      name='vehType'
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <Select
                            {...field}
                            status={fieldState.error ? 'error' : null}
                            placeholder='Vehicle Type min-h-[50px]'
                            className='w-full veh_selct cusInpDis'
                            suffixIcon={
                              <span className='custom_prefix_sel'>
                                <FaCarSide color='white' fontSize={18} />
                              </span>
                            }
                            options={settingsData.categories[
                              settingsIndex.cat
                            ].types.map((item) => {
                              return {
                                label: item.name,
                                value: item.id,
                              };
                            })}
                            onChange={(val) => {
                              field.onChange(val);
                            }}
                            disabled={true}
                          />
                        );
                      }}
                    />
                  </div>
                  <div className='w-[340px] max-w-full max-[600px]:w-full'>
                    <Controller
                      control={control}
                      name='min_val'
                      render={({ field }) => {
                        return (
                          <InputNumber
                            {...field}
                            type='number'
                            className={`genrate_inp w-full cusInpDis`}
                            addonBefore={
                              <FiDollarSign color='white' fontSize={18} />
                            }
                            placeholder='Min. PARF Value'
                            readOnly
                          />
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
            </form>
            <div className='p-[30px] relative max-[600px]:px-[15px]'>
              <div className='text-[#495159] text-[14px] max-w-full w-[650px]'>
                {/*  */}
                <p className='text-[16px] font-[600] mb-[4px]'>
                  Your Selected Loan ({selectedLoans.length})
                </p>
                An agent required to approve loan application for{' '}
                <strong className='text-[#0F172A] font-[600]'>Banks</strong>,{' '}
                <strong className='text-[#0F172A] font-[600]'>
                  Financial Institutions
                </strong>{' '}
                and{' '}
                <strong className='text-[#0F172A] font-[600]'>In House.</strong>
                <strong className='text-[#0F172A] font-[600] mt-[4px] inline-block'>
                  Select an agent to process your loan application.
                </strong>
              </div>
              <div className='mt-[30px]'>
                {/* {console.log("PRODUCTARRAY", orgApplLoanData,
                  Object.values(orgApplLoanData)?.map((it) => it?.length).map((itx, index) => itx !== 0 && index + 1),
                )} */}
                <Collapse
                  className='loanCollapse'
                  items={Array.from({
                    length: Object.keys(orgApplLoanData).length,
                  }).map((_, idx) => {
                    const keyName = Object.keys(orgApplLoanData)[idx];
                    return {
                      key: idx + 1,
                      label: `${keyName} (${orgApplLoanData[keyName].length})`,
                      children: (
                        <div className='flex flex-wrap gap-[30px_10px] py-[30px]'>
                          {orgApplLoanData[keyName].length > 0 ? (
                            orgApplLoanData[keyName].map((item, idx) => {
                              const actAgent = item.interestData.find(
                                (actItem) => actItem.hasPremium
                              );
                              let editItem = {
                                ...item,
                                defaultAgent: actAgent ? actAgent : null,
                              };
                              return (
                                <SelAgentCard
                                  key={idx}
                                  product={editItem}
                                  applyLoan
                                  selectedAgent={selectedAgent}
                                  context={{ setselAgentPop, setSelectedAgent }}
                                  selectedBonus={selectedBonus}
                                  setSelectedBonus={setSelectedBonus}
                                  setselectedLoans={setselectedLoans}
                                  selectedLoans={selectedLoans}
                                  HandleBonusChange={HandleBonusChange}
                                />
                              );
                            })
                          ) : (
                            <div className='w-full'>No Loan Product</div>
                          )}
                        </div>
                      ),
                    };
                  })}
                  defaultActiveKey={Object.values(orgApplLoanData)?.map((it) => it?.length).map((itx, index) => itx !== 0 && index + 1)}
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
  return (
    <div className='w-full min-h-screen bg-[#F5F5F5]'>
      <div className='text-[20px] font-[700] p-[18px_25px] bg-white'>
        New Loan Application
        <ConfirmationModal />
      </div>
      <form onSubmit={handleSubmit(genData)}>
        <div className='relative px-[10px]'>
          <div className='bg_grad_box h-[160px] absolute top-0 left-0 w-full'></div>
          <div className='relative'>
            <h3 className='text-white text-[22px] text-center font-[700] py-[25px]'>
              Find out your monthly Installment
            </h3>
            <div className='bg-white border border-[#F4F4F4] rounded-[8px] w-[1154px] max-w-full mx-auto p-[35px_30px] ln_ap_shad'>
              <div className='flex items-center justify-between gap-[15px] max-[600px]:flex-wrap'>
                <div className='w-[340px] max-w-full max-[600px]:w-full'>
                  <Controller
                    control={control}
                    name='loan_amt'
                    rules={{
                      required: true,
                    }}
                    render={({ field, fieldState }) => {
                      return (
                        <InputNumber
                          {...field}
                          status={fieldState.error ? 'error' : null}
                          type='number'
                          className='genrate_inp w-full'
                          addonBefore={
                            <FiDollarSign color='white' fontSize={18} />
                          }
                          placeholder='Loan Amount'
                        />
                      );
                    }}
                  />
                </div>
                <div className='w-[340px] max-w-full max-[600px]:w-full'>
                  <Controller
                    control={control}
                    name='loan_tnr'
                    rules={{
                      required: true,
                    }}
                    render={({ field, fieldState }) => {
                      return (
                        <InputNumber
                          {...field}
                          status={fieldState.error ? 'error' : null}
                          type='number'
                          min={tenureType === 'year' ? 1 : 12}
                          max={tenureType === 'year' ? 10 : 120}
                          className='genrate_inp w-full tenure-container'
                          addonBefore={
                            <FiCalendar color='white' fontSize={18} />
                          }
                          placeholder={`${tenureType === 'year'
                            ? 'Loan Tenor (Max. 10)'
                            : 'Loan Tenor (Max. 120)'
                            }`}
                          addonAfter={
                            <Select
                              defaultValue={tenureType}
                              onChange={tenureChange}
                              style={{
                                width: 100,
                              }}
                              bordered={false}
                              options={[
                                {
                                  value: 'year',
                                  label: 'Year',
                                },
                                {
                                  value: 'month',
                                  label: 'Month',
                                },
                              ]}
                            />
                          }
                        />
                      );
                    }}
                  />
                </div>
                <div className='w-[340px] max-w-full max-[600px]:w-full relative'>
                  <div className='absolute h-full w-full flex items-center justify-end z-[2] pointer-events-none'>
                    <img
                      src='/images/select_ar.svg'
                      className='mr-[13px] mt-[3px]'
                      alt='arrow'
                      width='12'
                      height='12'
                    />
                  </div>
                  <Controller
                    control={control}
                    name='vehType'
                    rules={{
                      required: true,
                    }}
                    render={({ field, fieldState }) => {
                      // //console.log(
                      //   'CATEGORIES',
                      //   settingsData.categories?.map((it) => it?.types).flat()
                      // );
                      return (
                        <Select
                          {...field}
                          status={fieldState.error ? 'error' : null}
                          placeholder='Vehicle Type'
                          className='w-full veh_selct min-h-[50px]'
                          suffixIcon={
                            <span className='custom_prefix_sel'>
                              <FaCarSide color='white' fontSize={18} />
                            </span>
                          }
                          options={settingsData.categories
                            ?.map((it) => it?.types)
                            .flat()
                            .map((item) => {
                              return {
                                label: item.name,
                                value: item.id,
                              };
                            })}
                          onChange={(val, option) => {
                            // //console.log(
                            //   'ONCHANGE',
                            //   settingsData.categories[0].types[
                            //   option?.label === 'PARF' ? 0 : 1
                            //   ]
                            // );
                            field.onChange(val);
                            if (
                              option?.label === 'PARF' ||
                              option?.label === 'COE'
                            ) {
                              setSettingsIndex({
                                ...settingsIndex,
                                cat: 0,
                                typ: option?.label === 'PARF' ? 0 : 1,
                              });
                              setApplyFilters({
                                ...applyFilters,
                                loanType: val,
                                scheme:
                                  settingsData.categories[0].types[
                                    option?.label === 'PARF' ? 0 : 1
                                  ].schemes[0].id,
                                category: settingsData?.categories[0]?.id,
                                settingIndex: {
                                  ...settingsIndex,
                                  cat: 0,
                                  typ: option?.label === 'PARF' ? 0 : 1,
                                },
                              });
                              dispacth(
                                setInitialLoanApplicationFilter({
                                  ...applyFilters,
                                  loanType: val,
                                  scheme:
                                    settingsData.categories[0].types[
                                      option?.label === 'PARF' ? 0 : 1
                                    ].schemes[0].id,
                                  category: settingsData?.categories[0]?.id,
                                  settingIndex: {
                                    ...settingsIndex,
                                    cat: 0,
                                    typ: option?.label === 'PARF' ? 0 : 1,
                                  },
                                })
                              );
                            } else {
                              setSettingsIndex({
                                ...settingsIndex,
                                cat: 1,
                                typ: 0,
                              });
                              setApplyFilters({
                                ...applyFilters,
                                loanType: val,
                                scheme:
                                  settingsData.categories[1].types[0].schemes[0]
                                    .id,
                                category: settingsData?.categories[1]?.id,
                                settingIndex: {
                                  ...settingsIndex,
                                  cat: 1,
                                  typ: 0,
                                },
                              });
                              dispacth(
                                setInitialLoanApplicationFilter({
                                  ...applyFilters,
                                  loanType: val,
                                  scheme:
                                    settingsData.categories[1].types[0]
                                      .schemes[0].id,
                                  category: settingsData?.categories[1]?.id,
                                  settingIndex: {
                                    ...settingsIndex,
                                    cat: 1,
                                    typ: 0,
                                  },
                                })
                              );
                            }
                          }}
                        />
                      );
                    }}
                  />
                </div>
              </div>
              <Divider className='my-[17px]' />
              {vehType === '3ae152dc-c962-49e5-a4d4-481c5a3c2743' ? (
                <div className='text-[14px] font-[500] text-center my-[30px]'>
                  <a className='text-[#0560FB] cursor-pointer mr-[6px] my-[25px]'>
                    BALLOON SCHEME
                  </a>
                  not applicable for COE vehicle type
                </div>
              ) : (
                <div className='flex items-center justify-end gap-[15px] max-[600px]:flex-wrap'>
                  {!vehType && minParfVal !== '' && minParfVal !== null ? (
                    <div className='text-[14px] text-[red] font-[500] mr-[25px] w-[500px] max-w-full max-[600px]:w-full max-[600px]:order-2'>
                      Fill up VEHICLE TYPE first, then ARF Paid(PARF Eligible
                      Vehicles) for balloon scheme monthly installment
                    </div>
                  ) : (
                    <div className='flex items-center flex-wrap gap-[0_7px] text-[14px] font-[500] mr-[25px] max-[600px]:w-full max-[600px]:order-2'>
                      Fill up Min. PARF value for
                      <a className='text-[#0560FB] cursor-pointer'>
                        BALLOON SCHEME
                      </a>{' '}
                      <span>
                        installment
                        <Popover content={schemeContent}>
                          <img
                            src='/images/fi_info.svg'
                            alt='info'
                            className='inline-block ml-[4px] cursor-pointer'
                          />
                        </Popover>
                      </span>
                    </div>
                  )}
                  <div className='w-[340px] max-w-full max-[600px]:w-full'>
                    <Controller
                      control={control}
                      name='min_val'
                      render={({ field }) => {
                        return (
                          <InputNumber
                            {...field}
                            type='number'
                            className='genrate_inp w-full'
                            addonBefore={
                              <FiDollarSign color='white' fontSize={18} />
                            }
                            placeholder='Min. PARF Value'
                          />
                        );
                      }}
                    />
                  </div>
                </div>
              )}
              <div className='text-center mt-[15px]'>
                {pagePermission?.create_permission == 1 && (
                  <ButtonBase
                    onClick={() => {
                      // clearCart();
                    }}
                    type='submit'
                    disabled={
                      !vehType && minParfVal !== '' && minParfVal !== null
                    }
                  >
                    <div className='inline-block text-[18px] font-[600] rounded-[5px] p-[13px_34px] bg-[#0560FB] text-white'>
                      Generate
                    </div>
                  </ButtonBase>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
      <div className='relative px-[10px] my-[40px]'>
        <ViewBonusPopup
          bonusPopUp={bonusPopUp}
          bonusData={allAgentData}
          closeBonusPop={() => setbonusPopUp(false)}
        />
        <div className='bg_grad_box h-[220px] absolute top-0 left-0 w-full'></div>
        <div className='relative'>
          <h3 className='text-white text-[22px] text-center font-[700] pt-[30px]'>
            Browse Loan Products & Rates
          </h3>
          <p className='text-center text-[13px] mt-[2px] text-white mb-[30px]'>
            Select your vehicle specifications to apply the correct loan type
          </p>
          <div className='ln_ap_shad bg-white border border-[#F4F4F4] rounded-[8px] w-[1154px] max-w-full mx-auto p-[30px_30px_14px_30px]'>
            <h3 className='text-[#495159] text-[16px] font-[700] mb-[15px]'>
              Select what best suits the vehicle...
            </h3>
            <div>
              <SwitchBox
                title='Vehicle'
                tabs={settingsData.vehicles}
                settingsHandle={settingsHandle}
                value={applyFilters?.vehicle}
              />
              <SwitchBox
                title='Type'
                tabs={settingsData.categories}
                settingsHandle={settingsHandle}
                value={applyFilters?.category}
              />
              <LnSwitchBox
                title='Category'
                tabs={settingsData.categories[settingsIndex.cat].types}
                settingsHandle={settingsHandle}
                value={applyFilters.loanType}
              />
              <SwitchBox
                title='Motor'
                tabs={settingsData.productMotorTypes}
                settingsHandle={settingsHandle}
                value={applyFilters.motorType}
              />
              <SwitchBox
                title='Usage'
                tabs={settingsData.productUsages}
                settingsHandle={settingsHandle}
                value={applyFilters?.usage}
              />
              {/* {//console.log(
                'SCHEMEDATA',
                settingsData.categories[settingsIndex.cat].types[
                  settingsIndex.typ
                ].schemes
              )} */}
              <LnSwitchBox
                title='Scheme'
                tabs={
                  settingsData.categories[settingsIndex.cat].types[
                    settingsIndex.typ
                  ].schemes.map((scheme) => ({
                    ...scheme,
                    disabled:
                      settingsData.vehicles[settingsIndex.veh]?.name === 'Commercial' &&
                      scheme.name === 'Balloon',
                  }))
                }
                settingsHandle={settingsHandle}
                value={applyFilters.scheme}
              />
              <br />
              <SwitchBox
                title='Approval Time'
                tabs={settingsData.approvalTimes}
                info='info'
                settingsHandle={settingsHandle}
                value={applyFilters?.approvalTime}
              />
              <SwitchBox
                title='Loan to Value'
                tabs={settingsData.ltvs}
                info='info'
                settingsHandle={settingsHandle}
                value={applyFilters?.ltv}
              />
              <BonusSwitchBox
                title='Bonus'
                tabs={[
                  { name: 'All', val: 'all' },
                  { name: 'Yes', val: '1' },
                  { name: 'No', val: '0' },
                ]}
                info='info'
                settingsHandle={settingsHandle}
                value={applyFilters.bonus}
              />
              <BonusSwitchBox
                title='Collect First Installment?'
                tabs={[{ name: 'All', val: 'all' }].concat(
                  settingsData.collect_first_installment_options?.map((it) => {
                    return {
                      ...it,
                      val: it.value,
                    };
                  })
                )}
                info='info'
                settingsHandle={settingsHandle}
                value={applyFilters.collect_first_installment}
              />
              <div className='relative'>
                <SwitchButton
                  handleSwitchButton={handleSwitchButton}
                  right={applyFilters?.toggleSwitch}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-[70px] pb-[70px] px-[30px]'>
        {prodLoading ? (
          <LoaderComp />
        ) : (
          <div className='flex flex-wrap gap-[35px_20px]'>
            {loanProductList.length > 0 ? (
              loanProductList.map((item, idx) => {
                const interestRates = item.interests.map((interest) =>
                  parseFloat(interest.interest)
                );
                const lowestInterestIndex = interestRates.indexOf(
                  Math.min(...interestRates)
                );
                const highestInterestIndex = interestRates.indexOf(
                  Math.max(...interestRates)
                );
                return (
                  <BankCard
                    key={idx}
                    product={item}
                    allAgentBonus={handleAgentBonusPop}
                    interestSort={
                      switchButton ? lowestInterestIndex : highestInterestIndex
                    }
                  />
                );
              })
            ) : (
              <h3 className='text-center w-full text-[24px] font-bold'>
                No Products
              </h3>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoanAppl;
